import { render, staticRenderFns } from "./NottinghamCity.vue?vue&type=template&id=b1da3cf0&scoped=true&"
import script from "./NottinghamCity.vue?vue&type=script&lang=js&"
export * from "./NottinghamCity.vue?vue&type=script&lang=js&"
import style0 from "./NottinghamCity.vue?vue&type=style&index=0&id=b1da3cf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1da3cf0",
  null
  
)

export default component.exports